module.exports = __webpack_public_path__ + "img/t3-name.593c59fb.png";